import React from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'

export const ListKPIHarian: React.FC = () => {
  return (
    <Section title="Dashboard Pemantauan KPI Harian">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          data-testid="dashboard-iframe"
          src={env.iFrameMetabaseKPIHarian}
          frameBorder="0"
          width="100%"
          height="600"
          allowTransparency
        ></iframe>
      </div>
    </Section>
  )
}